import { useEffect, useMemo } from "react"
import { Outlet, useLocation } from "react-router"
import {
    getGenericWorkspacePage,
    getGenericWorkspacePageHeader,
} from "panels/routing/WorkspaceRoutes"
import { useRouter } from "pages"
import { TabHeader } from "themes/default-tailwind/buttons/TabHeader"
import { ApiTokenTabContent } from "./ApiTokenTab"
import { ApiDocsTabContent } from "./ApiDocsTab"
import { ApiExploreTabContent } from "./ApiExploreTab"

export const ApiSettingsPage = getGenericWorkspacePage({
    Header: getGenericWorkspacePageHeader({ title: "Processing API", border: false }),
    Content: ApiSettingsPageContent,
    maxWidth: 1100,
})

function ApiSettingsPageContent() {
    const router = useRouter("/workspace/:workspaceId")
    const location = useLocation()
    const currentMode = useMemo(() => {
        const tokenTab = router.preview({ path: "/settings/api/token" })
        const docsTab = router.preview({ path: "/settings/api/docs" })
        const exploreTab = router.preview({ path: "/settings/api/explore" })
        if (location.pathname === tokenTab) return "token"
        if (location.pathname === docsTab) return "docs"
        if (location.pathname === exploreTab) return "explore"
        return ""
    }, [location.pathname, router])

    return (
        <div className="w-full h-full flex flex-col gap-5 overflow-hidden">
            <div className="flex">
                <TabHeader
                    currentMode={currentMode}
                    mode="token"
                    setActiveMode={() => router.navigate({ path: "/settings/api/token" })}
                    title="Token"
                />
                <TabHeader
                    currentMode={currentMode}
                    mode="docs"
                    setActiveMode={() => router.navigate({ path: "/settings/api/docs" })}
                    title="Documentation"
                />
                <TabHeader
                    currentMode={currentMode}
                    mode="explore"
                    setActiveMode={() => router.navigate({ path: "/settings/api/explore" })}
                    title="Explore"
                />
                <div className="flex-1 border-b-2 border-b-white-200" />
            </div>
            <div className="grow overflow-hidden rounded-lg border border-gray-700">
                <Outlet />
            </div>
        </div>
    )
}

export const ApiSettingsRedirect = () => {
    const router = useRouter("/workspace/:workspaceId")
    useEffect(() => {
        router.navigate({ path: "/settings/api/token" }, { replace: true })
    }, [router])
    return null
}

export const ApiTokenTabPage = () => (
    <div className="w-full h-full pb-6">
        <ApiTokenTabContent />
    </div>
)

export const ApiDocsTabPage = () => (
    <div className="w-full h-full pb-6">
        <ApiDocsTabContent />
    </div>
)

export const ApiExploreTabPage = () => (
    <div className="w-full h-full pb-6">
        <ApiExploreTabContent />
    </div>
)
